module.exports = {
      id: "youtube-plain-usage",
      viewBox: "0 0 29 20",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#youtube-plain",
      toString: function () {
        return this.url;
      }
    }